import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const getMarketplaceDescAddVendorCode = () => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId:  userData.smsAuth.userId,
    }
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    try {
        const { data: { status, data } } = await apiInstance.post('/sales/marketplaces/getMarketplaceDescAddVendorCode', params, config)
        
        if(status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setMpDescAddVendorCode,
                value: data.mpDescAddVendorCode
            })
        }
    } catch (e) {
        console.error('get mpDescAddVendorCode failed', e)
    }

}


export default getMarketplaceDescAddVendorCode
